import { Directive, effect, HostBinding, inject, Input, OnChanges } from '@angular/core'
import { SignalStore } from '@src/app/core/store/signalStore.js'

@Directive({
  selector: '[ghost]',
  standalone: false,
})
export class GhostDirective implements OnChanges {
  private store = inject(SignalStore)

  @Input('ghost')
  extraGhostCondition = false

  @Input()
  disableGhost = false

  @HostBinding('class.ghost')
  ghost = false

  @HostBinding('attr.disabled')
  disabled?: boolean

  constructor() {
    effect(() => {
      this.ghost = this.store.$ghost()
      this.setDisabled()
    })
  }

  ngOnChanges(): void {
    this.setDisabled()
  }

  setDisabled(): void {
    if (this.disableGhost) {
      this.disabled = undefined
    } else {
      this.disabled = this.ghost || this.extraGhostCondition || undefined
    }
  }
}
